// extracted by mini-css-extract-plugin
export default {"section":"Nw-z","inSectionButton":"Ow-z","addressCard":"Pw-z","disabled":"Qw-z","cautionBox":"Rw-z","failureBox":"Sw-z","fade-out":"Tw-z","successBox":"Uw-z"};